import { ENV_CONFIG } from '@/envConfig.ts';
import { wait } from '@/common/utils/wait.ts';
import { ResponseBase } from '@/common/api/schemas.ts';
import { mockSession } from '@/lib/mockSession.ts';
import { redirectToLogin } from '@/features/auth/utils/redirectToLogin';

export type MockOptions<TResponse extends ResponseBase> = {
  mock?: (() => TResponse) | TResponse;
  unauthenticated?: boolean;
};

export async function handleMock<TResponse extends ResponseBase>(
  mockOptions: MockOptions<TResponse>
) {
  if (!mockOptions.unauthenticated && !mockSession.isLoggedIn()) {
    await redirectToLogin();
    throw new Error('Not authenticated');
  }

  if (ENV_CONFIG.apiDebugDelay > 0) {
    await wait(ENV_CONFIG.apiDebugDelay);
  }

  const handler = mockOptions.mock;

  if (typeof handler === 'function') {
    return handler();
  }
  return handler;
}
